$(document).ready(function () {
    let open = 0;
    let sidePanels = {};
    let availableSidePanels = {};
    window.bootstrapDatepickerConfig ??= {
        dateFormat: 'dd-mm-yy',
        firstDay: 1,
        ignoreReadonly: true,
        orientation: 'right bottom',
        forceParse: false,
        format: {
            /*
             * Say our UI should display a week ahead,
             * but textbox should store the actual date.
             * This is useful if we need UI to select local dates,
             * but store in UTC
             */
            toDisplay: function (date, format, language) {
                return moment(date).format('DD-MM-YYYY');
            },
            toValue: function (date, format, language) {
                return moment(date).format('YYYY-MM-DD');
            }
        }
    };

    window.tinyMceConfig ??= {
        forced_root_block: "",
        plugins: 'lists advlist link paste image code visualchars',
        toolbar: 'formatselect undo redo bullist numlist bold italic visualchars forecolor link image removeformat code alignleft aligncenter alignright',
        extended_valid_elements: '*[*]',
        menubar: false,
        width: '100%',
        paste_data_images: true,
        link_class_list: [
            {title: 'None', value: ''},
            {title: 'Primary button', value: 'btn btn-primary btn-sm'},
            {title: 'Success button', value: 'btn btn-success btn-sm'}
        ],
        visualchars_default_state: false
    }
    window.tinyMceConfig.height = 'calc(100vh - 300px)';
    window.tinyMceConfig.setup = function (editor) {
        editor.on('keydown', function (evt) {
            if (evt.keyCode === 9) { // tab pressed
                editor.execCommand('mceInsertContent', false, '\x09'); // inserts tab
                evt.preventDefault();
                // evt.stopPropagation();
                return false;
            }
        });
    }

    // window.tinyMceConfig.setup = function (ed) {
    //     console.log(ed.onkeydown)
    //
    //     ed.on('keydown', function (evt) {
    //         console.log(evt.keyCode)
    //         if (evt.keyCode === 9) { // tab pressed
    //             // ed.execCommand('mceInsertRawHTML', false, '\x09'); // inserts tab
    //             // evt.preventDefault();
    //             // evt.stopPropagation();
    //             return false;
    //         }
    //     });
    // }

    if ($.fn.getFormDataAssociative === undefined || $.fn.fillFormErrors === undefined) {
        require('./jQuery.formData.extension');
    }

    /** Init side panel */
    sidePanels.init = (_this) => {
        let sidePanel = $(_this);
        sidePanel.content = sidePanel.find('.side-panel-body');
        sidePanel.loaded = false;
        sidePanel.refreshAlways = !!sidePanel.data().reload ?? true;
        sidePanel.route = sidePanel.mainRoute = sidePanel.data().route;
        sidePanel.close = (e) => {
            sidePanel = sidePanels.getCurrentSidePanel();
            sidePanel.trigger('nc.sidePanel.hide');
            sidePanel.fadeOut(200);
            sidePanel.forgetTarget(open);
            sidePanel.trigger('nc.sidePanel.hidden');
            try {
                sidePanel.content.find('.tinymce').tinymce('destroy');
            } catch (e) {
            }
            sidePanel.content.find(['data-toggle^="#data-side"']).unbind();
            if (sidePanel.refreshAlways === true) {
                sidePanel.content.html('');
            }
        }
        sidePanel.reload = () => {
            sidePanel.loadURL(sidePanel.url)
        };
        sidePanel.loadURL = (url) => {
            loadUrl(sidePanel, url)
        }
        registerMethods(sidePanel);
        registerEvents(sidePanel);
        registerLoader(sidePanel);
        availableSidePanels[sidePanel.id] = sidePanel;
    }

    sidePanels.getSidePanels = () => {
        let panels = []
        for (let k in window.sidePanels) {
            if (window.sidePanels.hasOwnProperty(k) && typeof window.sidePanels[k] === 'object') {
                panels[k] = window.sidePanels[k];
            }
        }

        return panels;
    }

    sidePanels.open = (elem = $, route = null, target = $) => {
        if (!elem.is('[id^="data-side-panel-"]')) {
            throw new Error('The given element is not a valid side panel.')
        }

        let sidePanel = availableSidePanels[elem.id];
        if (route)
            sidePanel.route = route;

        openSidePanel(sidePanel, target);
    }

    sidePanels.getCurrentSidePanel = () => {
        return window.sidePanels.getSidePanels().reverse()[0];
    }

    window.sidePanels = sidePanels;

    /** Register all sidePanels available in DOM */
    $('[id^="data-side-panel-"]').each(function (k, i) {
        sidePanels.init(i);
    });

    function registerMethods(sidePanel) {
        /** Targets */
        sidePanel.registerTarget = (target) => {
            sidePanel.target = target
            let exists = false;
            let currentSidePanels = sidePanels.getSidePanels();

            if (currentSidePanels.length) {
                for (let k in currentSidePanels) {
                    if (exists === false && currentSidePanels.hasOwnProperty(k)) {
                        if (currentSidePanels[k][0].id === sidePanel[0].id) {
                            exists = true;
                            break;
                        }
                    }
                }
            }

            if (exists) {
                open--
                delete sidePanels[open];
            }

            sidePanels[open] = sidePanel;
            window.sidePanels = sidePanels;
            open = sidePanels.getSidePanels().length
        }
        sidePanel.forgetTarget = () => {
            delete sidePanels[(open - 1)];
            window.sidePanels = sidePanels;
            open = sidePanels.getSidePanels().length
        }
    }

    function registerEvents(sidePanel) {
        /** Open side panel */
        $(document).on('click', '[data-toggle="#' + sidePanel[0].id + '"]:not(.disabled)', (e) => {
            let item = $(e.target)

            if (item.not('[data-toggle="#' + sidePanel[0].id + '"]')) {
                item = item.closest('[data-toggle="#' + sidePanel[0].id + '"]');
            }

            if (item.data().route !== undefined && item.data().route.length) {
                sidePanel.route = item.data().route;
            } else {
                sidePanel.route = sidePanel.mainRoute;
            }

            openSidePanel(sidePanel, item);
        });

        /** Close side panel */
        sidePanel.before().mousedown((e) => {
            e.target.id === sidePanel[0].id ? sidePanel.close() : '';
        });
        sidePanel.find('.side-panel-close').click(() => {
            sidePanel.close();
        });
    }

    function openSidePanel(sidePanel, target) {
        let width;
        if (sidePanel.loaded === false || sidePanel.refreshAlways === true) {
            sidePanel.trigger('nc.sidePanel.show', sidePanel);
            if (sidePanel.route.length) {
                sidePanel.loader.open();
                sidePanel.url = sidePanel.route;
                sidePanel.content.load(sidePanel.route, null, function () {
                    sidePanel.loader.close();

                    registerLinks(sidePanel);
                    registerForm(sidePanel);
                    registerSortableTables();
                    initializeJsComponents(sidePanel)
                    sidePanel.loaded = true;
                    sidePanel.trigger('nc.sidePanel.shown');
                })
            } else {
                registerLinks(sidePanel);
                registerForm(sidePanel);
                registerSortableTables();
                sidePanel.loaded = true;
                sidePanel.trigger('nc.sidePanel.shown');
                initializeJsComponents(sidePanel)
            }
        }

        sidePanel.registerTarget(target)
        sidePanel.fadeIn(200);

        if (width === undefined) {
            width = sidePanel.width();
        }

        if (window.sidebars !== undefined) {
            /** TODO: remove when sidebars are totally removed from pub */
            let openTotalPub = (open + window.sidebars.getSidebars().length);
            sidePanel.width(width - (50 * (openTotalPub)));
            sidePanel.css('z-index', 2000 + openTotalPub);
        } else {
            sidePanel.width(width - (50 * open));
        }
    }

    function registerLinks(sidePanel) {
        /** Follow links */
        sidePanel.content.find('a[target!="_blank"]:not(.cancelForm):not(.follow)').click((e) => {
            e.preventDefault();
            sidePanel.loader.open();
            sidePanel.trigger('nc.sidePanel.reload');
            if (!$(e.target).is('a')) {
                e.target = $(e.target).closest('a')[0];
            }
            loadUrl(sidePanel, e.target.href);
        });
    }

    function loadUrl(sidePanel, url) {
        sidePanel.content.load(url, null, () => {
            registerLinks(sidePanel);
            registerForm(sidePanel);
            registerSortableTables();
            sidePanel.content.find('[id^=data-side-panel-]').each(function (k, i) {
                sidePanels.init(i);
            });
            initializeJsComponents(sidePanel)
            sidePanel.loader.close();
            sidePanel.trigger('nc.sidePanel.reloaded');
            sidePanel.url = url;
        });
    }

    function registerForm(sidePanel) {
        /** Register form */
        sidePanel.form = sidePanel.content.find('form:not(.disabled)');

        /** Form handling */
        sidePanel.form.each((k, form) => {
            $(form).submit((e) => {
                e.preventDefault();
                sidePanel.loader.open();
                $.post({
                    url: e.target.action,
                    dataType: 'JSON',
                    processData: false,
                    contentType: false,
                    data: $(form).getFormDataAssociative(),
                    success: (result) => {
                        if ($(form).closest('[id^="data-side-panel-"]').is(sidePanel)) {
                            sidePanel.trigger('nc.sidePanel.formSuccess', [result]);
                        }

                        if (result.route !== undefined && result.route.length) {
                            sidePanel.loadURL(result.route);
                        }

                        if (result.routeReloadPage !== undefined && result.routeReloadPage.length) {
                            window.location.href = result.routeReloadPage;
                        }
                    },
                    error: (error) => {
                        sidePanel.trigger('nc.sidePanel.formError', error);
                        if (error.status === 422) {
                            sidePanel.form.fillFormErrors(error.responseJSON.errors)
                        }
                    },
                    complete: () => {
                        sidePanel.loader.close();
                    }
                })
            })
        })
    }

    function registerLoader(sidePanel) {
        sidePanel.loader = sidePanel.find('.side-panel-loader');

        /** Open */
        sidePanel.loader.open = () => {
            sidePanel.trigger('nc.sidePanel.loader.show');
            sidePanel.loader.fadeIn(200);
            sidePanel.trigger('nc.sidePanel.loader.shown');
        }

        /** Close */
        sidePanel.loader.close = () => {
            sidePanel.trigger('nc.sidePanel.loader.hide');
            sidePanel.loader.fadeOut(150);
            sidePanel.trigger('nc.sidePanel.loader.hidden');
        }
    }

    function registerSortableTables() {
        if (window.hasOwnProperty('createSortableTables')) {
            window.createSortableTables();
        }
    }

    function initializeJsComponents(sidePanel) {
        sidePanel.content.find('[data-toggle="tooltip"]').tooltip()
        sidePanel.content.find('.selectpicker').selectpicker();
        sidePanel.content.find('.datepicker').datepicker(bootstrapDatepickerConfig);

        try {
            sidePanel.content.find('.tinymce').each(function () {
                if($(this).hasClass('tinymce-sm')) {
                    tinyMceConfig.height = '250px';
                    $(this).tinymce(tinyMceConfig);
                    return;
                }
                $(this).tinymce(tinyMceConfig);
            });
        } catch (e) {
            console.log(e);
            //
        }
        sidePanel.content.find('[id^="data-side-panel-"]').each(function (k, i) {
            sidePanels.init(i);
        });
    }

});
